function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as l } from "react/jsx-runtime";
import { vars as a } from "../skins/skin-contract.css-mistica.js";
const c = (param)=>/* @__PURE__ */ {
    let { size: o , color: t , transform: r , className: n , style: e  } = param;
    return l("svg", {
        role: "presentation",
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        className: n,
        style: e,
        children: /* @__PURE__ */ l("path", {
            style: {
                transition: "transform 0.3s"
            },
            fill: t,
            fillRule: "evenodd",
            d: "M14.338 11.478a.75.75 0 0 1 0 1.044l-3.837 3.997a.75.75 0 1 1-1.082-1.038L12.76 12 9.42 8.52a.75.75 0 0 1 1.082-1.04l3.837 3.998z",
            transform: r
        })
    });
}, h = {
    up: -90,
    down: 90,
    left: 180,
    right: 0
}, f = (param)=>{
    let { size: o = 24 , color: t , className: r , style: n , direction: e = "right"  } = param;
    const i = t || a.colors.neutralHigh, s = {
        size: o,
        color: i,
        transform: `rotate(${h[e]} 12 12)`,
        className: r,
        style: n
    };
    return /* @__PURE__ */ l(c, _object_spread({}, s));
}, v = f;
export { v as default };
